const Capitalize = function (string) {
  return string[0].toUpperCase() + string.substring(1)
}

export default Capitalize
